import { StyledCardItem } from './styles';
import { TCardItem } from './types';

export const CardItem = ({ children, ...otherProps }: TCardItem) => {
  return <StyledCardItem {...otherProps}>{children}</StyledCardItem>;
};
